// Round the discounted unit price once, before multiplying by quantity.
export function readerPrice(price, format, participating = false, member = false) {
  const cents = Math.round(Number(price) * 100);
  if (!Number.isFinite(cents) || cents < 0) return null;
  if (!participating || !member) return cents / 100;
  const ebook = String(format || '').toLowerCase().replace(/\s+/g, '') === 'ebook';
  return (ebook ? (cents >= 300 ? cents - 100 : cents) : Math.round(cents * 0.9)) / 100;
}
